import { createApp } from "vue";

import colors from "vuetify/util/colors";
import "@mdi/font/css/materialdesignicons.css";

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "../src/styles/global.css";
import VueEasyLightbox from "vue-easy-lightbox/external-css";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueApexCharts from "vue3-apexcharts";
import VueTheMask from "vue-the-mask";

const app = createApp(App);
const APP_NAME = "Maker Market";

app.component("ApexChart", VueApexCharts);

router.beforeEach((to) => {
  const pageTitle = to.meta.title;
  const pageDescription = to.meta.description;

  if (pageTitle) {
    document.title = `${pageTitle} | ${APP_NAME}`;
  } else {
    document.title = APP_NAME;
  }

  const oldMeta = document.querySelector("meta[name='description']");
  if (oldMeta) {
    oldMeta.remove();
  }

  if (pageDescription) {
    const meta = document.createElement("meta");
    meta.name = "description";
    meta.content = pageDescription;
    document.head.appendChild(meta);
  }
});

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        dark: false,
        colors: {
          background: "#f5f5f5",
          primary: "#EEC31C",
          secondary: colors.grey.darken4,
          tertiary: "#f5f5f5",
          info: "#1976d2",
          confirm: "#2e7d32",
          view: "#EEC31C",
          reject: "#c62828",
        },
      },
      dark: {
        dark: true,
        colors: {
          background: "#151414",
          surface: "#1E1E1E",
          primary: "#EEC31C",
          secondary: colors.grey.lighten4,
          tertiary: "#313131",
          info: "#90caf9",
          confirm: "#A5D6A7",
          view: "#EEC31C",
          reject: "#ef9a9a",
        },
      },
    },
  },
});

export default vuetify;

app.use(vuetify);
app.use(VueTheMask);
app.use(router);
app.use(store);
app.use(VueEasyLightbox);
app.mount("#app");
